import { Status } from "@/app/shared_enums/enums";
import { TableResponse } from "./shared_types";
export enum ReRouteType {
  WITHIN_DEPT = "within_department",
  ACROSS_DEPT = "across_department",
}

export interface Department {
  id?: number;
  name: string;
  org_id: number;
  logo?: string;
  status: Status;
  ticket_rerouting: ReRouteType;
  code: string;
  description?: string;
  person_name?: string;
  contact_person?: string;
  contact_number?: string;
}

export type DepartmentTable = TableResponse<Department>;
interface Schedule {
  day: string;
  opening_time: string; // ISO 8601 format
  closing_time: string; // ISO 8601 format
  ticket_end_time: string; // ISO 8601 format
}

export interface ServiceofDepartment {
  id: number;
  name: string;
  is_multi_step: boolean;
  schedule: Schedule[];
  img?:string
}
